import { AudioProcessor } from "../../utils/AudioProcessor";
import { microTrack } from "./state";
import { isCurrentSession, sessionActive } from "./pipe";
import { resumeAudioContext } from "../audioCtx";
import type { MediaDesired } from "./state";

export async function muteTask(desired: MediaDesired) {
  if (!sessionActive.value) return;
  // Mute/unmute — пользовательское действие: разбуживаем аудиоконтексты, чтобы
  // последующий unmute не оставил микрофон немым.
  resumeAudioContext();
  const track = microTrack.value;
  if (!track) return;
  // Трек захвачен в текущей сессии (поколение актуально) — mute/unmute ниже
  // не может задеть трек более новой сессии. Повторная проверка после await
  // защищает commit processor.setMuted от cleanup посреди ожидания.
  if (!isCurrentSession(desired.generation)) return;
  if (!desired.microEnabled && !track.isMuted) {
    await track.mute();
    // Трек мог быть остановлен (cleanup), пока ждали mute.
    if (isCurrentSession(desired.generation) && microTrack.value === track) {
      const processor = track.getProcessor() as AudioProcessor;
      if (processor) {
        processor.setMuted(true);
      }
    }
  } else if (desired.microEnabled && track.isMuted) {
    await track.unmute();
    if (isCurrentSession(desired.generation) && microTrack.value === track) {
      const processor = track.getProcessor() as AudioProcessor;
      if (processor) {
        processor.setMuted(false);
      }
    }
  }
}
